import { RestApiResponseWithData } from '@repo/debit-order-portal-shared';
import { appApiClient } from '../../config/axiosWrapper';
import { endpoints } from '../../config/endpoints';
import { IGetUserWithUserRolesDto } from './getCurrentUserDto';

export const getCurrentUser = async (): Promise<
  RestApiResponseWithData<IGetUserWithUserRolesDto>
> => {
  return appApiClient.get(`v1/${endpoints.USER}/current-user`);
};
